import _ from 'lodash';
import { isNullOrUndefinedOrEmpty } from '../../../helpers/common';
export const getWithProperty = (recordName, updateProperty) => recordName.replace(/\.[^.]+$/, `.${updateProperty}`);
export const makeValidateTitleAndFileForFile = (titleName, fileName) => (value, record, props, currentName) => {
    const fileTarget = getWithProperty(currentName, fileName);
    const titleTarget = getWithProperty(currentName, titleName);
    const fileData = _.get(record, fileTarget);
    const titleData = _.get(record, titleTarget);
    // アップロード済み、タイトル未入力の場合はOK
    if (fileData || isNullOrUndefinedOrEmpty(titleData)) {
        return '';
    }
    return value ? '' : 'タイトルを入力する場合、ファイルを選択してください';
};
